import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import MyProposals from "@/pages/MyProposals";

export const Route = createFileRoute("/en/account/quotes")({
  head: () => ({
    meta: [
      { title: "My quotes | Retail Lemon" },
      { name: "description", content: "Quotes already negotiated for your business." },
      { property: "og:title", content: "My quotes | Retail Lemon" },
      { property: "og:description", content: "Quotes already negotiated for your business." },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => (
    <ProtectedRoute>
      <MyProposals />
    </ProtectedRoute>
  ),
});
